// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import sendToGoogleAnalytics from '../../../_libs/analytics/builder-send-to-google-analytics';
import { FILTER_EFFECTS_OPTIONS } from '../../../_utils/advanced_editor/filter-effects-options';

class FilterButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      effect: props.defaultValue,
    };
  }

  render() {
    const { label: selectedLabel, value: selectedValue } =
      FILTER_EFFECTS_OPTIONS.reduce((selected, option) =>
        option.value == this.state.effect ? option : selected,
      );

    return (
      <div className="filters">
        <label tabIndex="0">
          Filters
          <span className="d-none d-lg-inline text-capitalize">
            : {selectedLabel}
          </span>
        </label>
        <div className="d-flex">
          {FILTER_EFFECTS_OPTIONS.filter(
            ({ value }) => (this.props.urls || {})[value],
          ).map(({ label, value }) => {
            return (
              <button
                aria-label={label}
                aria-pressed={selectedValue == value}
                className={classNames('btn btn-link p-0', {
                  selected: selectedValue == value,
                })}
                key={value}
                title={label}
                onClick={this.handleClick.bind(this, value)}
                disabled={this.props.disabled}>
                <img
                  alt={`${label} filter`}
                  className="h-100 w-100"
                  role="presentation"
                  src={this.props.urls[value]}
                />
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  handleClick(value) {
    if (this.props.disabled) {
      return;
    }
    this.setState(
      {
        effect: value,
      },
      function () {
        this.props.onChange(value);
      },
    );

    sendToGoogleAnalytics('el2', `filter-${value}`);
  }
}

FilterButtons.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  urls: PropTypes.shape({ [PropTypes.string]: PropTypes.string }),
  disabled: PropTypes.bool,
};

FilterButtons.defaultOptions = {
  urls: {},
  defaultValue: null,
  disabled: false,
};

export default FilterButtons;
